function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import cx from 'clsx';
import _ from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { childrenUtils, createHTMLInput, createShorthandFactory, customPropTypes, getComponentType, getUnhandledProps, partitionHTMLProps, getKeyOnly, getValueAndKey, setRef } from '../lib';
import Button from '../Button';
import Icon from '../Icon';
import Label from '../Label';

/**
 * An Input is a field used to elicit a response from a user.
 * @see Button
 * @see Form
 * @see Icon
 * @see Label
 */
var Input = /*#__PURE__*/React.forwardRef(function (props, _ref) {
  var action = props.action,
    actionPosition = props.actionPosition,
    children = props.children,
    className = props.className,
    disabled = props.disabled,
    error = props.error,
    fluid = props.fluid,
    focus = props.focus,
    icon = props.icon,
    iconPosition = props.iconPosition,
    input = props.input,
    inverted = props.inverted,
    label = props.label,
    labelPosition = props.labelPosition,
    loading = props.loading,
    size = props.size,
    tabIndex = props.tabIndex,
    transparent = props.transparent,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type;
  var computeIcon = function computeIcon() {
    if (!_.isNil(icon)) {
      return icon;
    }
    if (loading) {
      return 'spinner';
    }
  };
  var computeTabIndex = function computeTabIndex() {
    if (!_.isNil(tabIndex)) {
      return tabIndex;
    }
    if (disabled) {
      return -1;
    }
  };
  var handleChange = function handleChange(e) {
    var newValue = _.get(e, 'target.value');
    _.invoke(props, 'onChange', e, _objectSpread(_objectSpread({}, props), {}, {
      value: newValue
    }));
  };
  var partitionProps = function partitionProps() {
    var unhandledProps = getUnhandledProps(Input, props);
    var _partitionHTMLProps = partitionHTMLProps(unhandledProps),
      _partitionHTMLProps2 = _slicedToArray(_partitionHTMLProps, 2),
      htmlInputProps = _partitionHTMLProps2[0],
      rest = _partitionHTMLProps2[1];
    return [_objectSpread(_objectSpread({}, htmlInputProps), {}, {
      disabled: disabled,
      type: type,
      tabIndex: computeTabIndex(),
      onChange: handleChange,
      ref: _ref
    }), rest];
  };
  var classes = cx('ui', size, getKeyOnly(disabled, 'disabled'), getKeyOnly(error, 'error'), getKeyOnly(fluid, 'fluid'), getKeyOnly(focus, 'focus'), getKeyOnly(inverted, 'inverted'), getKeyOnly(loading, 'loading'), getKeyOnly(transparent, 'transparent'), getValueAndKey(actionPosition, 'action') || getKeyOnly(action, 'action'), getValueAndKey(iconPosition, 'icon') || getKeyOnly(icon || loading, 'icon'), getValueAndKey(labelPosition, 'labeled') || getKeyOnly(label, 'labeled'), 'input', className);
  var ElementType = getComponentType(props);
  var _partitionProps = partitionProps(),
    _partitionProps2 = _slicedToArray(_partitionProps, 2),
    htmlInputProps = _partitionProps2[0],
    rest = _partitionProps2[1];

  // Render with children
  // ----------------------------------------
  if (!childrenUtils.isNil(children)) {
    // add htmlInputProps to the `<input />` child
    var childElements = _.map(React.Children.toArray(children), function (child) {
      if (child.type === 'input') {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread(_objectSpread({}, htmlInputProps), child.props), {}, {
          ref: function ref(c) {
            setRef(child.ref, c);
            setRef(_ref, c);
          }
        }));
      }
      return child;
    });
    return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
      className: classes
    }), childElements);
  }

  // Render Shorthand
  // ----------------------------------------
  var actionElement = Button.create(action, {
    autoGenerateKey: false
  });
  var labelElement = Label.create(label, {
    defaultProps: {
      className: cx('label',
      // add 'left|right corner'
      _.includes(labelPosition, 'corner') && labelPosition)
    },
    autoGenerateKey: false
  });
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes
  }), actionPosition === 'left' && actionElement, labelPosition !== 'right' && labelElement, createHTMLInput(input || type, {
    defaultProps: htmlInputProps,
    autoGenerateKey: false
  }), Icon.create(computeIcon(), {
    autoGenerateKey: false
  }), actionPosition !== 'left' && actionElement, labelPosition === 'right' && labelElement);
});
Input.displayName = 'Input';
Input.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  /** An Input can be formatted to alert the user to an action they may perform. */
  action: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),
  /** An action can appear along side an Input on the left or right. */
  actionPosition: PropTypes.oneOf(['left']),
  /** Primary content. */
  children: PropTypes.node,
  /** Additional classes. */
  className: PropTypes.string,
  /** An Input field can show that it is disabled. */
  disabled: PropTypes.bool,
  /** An Input field can show the data contains errors. */
  error: PropTypes.bool,
  /** Take on the size of its container. */
  fluid: PropTypes.bool,
  /** An Input field can show a user is currently interacting with it. */
  focus: PropTypes.bool,
  /** Optional Icon to display inside the Input. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),
  /** An Icon can appear inside an Input on the left or right. */
  iconPosition: PropTypes.oneOf(['left']),
  /** Shorthand for creating the HTML Input. */
  input: customPropTypes.itemShorthand,
  /** Format to appear on dark backgrounds. */
  inverted: PropTypes.bool,
  /** Optional Label to display along side the Input. */
  label: customPropTypes.itemShorthand,
  /** A Label can appear outside an Input on the left or right. */
  labelPosition: PropTypes.oneOf(['left', 'right', 'left corner', 'right corner']),
  /** An Icon Input field can show that it is currently loading data. */
  loading: PropTypes.bool,
  /**
   * Called on change.
   *
   * @param {ChangeEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and a proposed value.
   */
  onChange: PropTypes.func,
  /** An Input can vary in size. */
  size: PropTypes.oneOf(['mini', 'small', 'large', 'big', 'huge', 'massive']),
  /** An Input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Transparent Input has no background. */
  transparent: PropTypes.bool,
  /** The HTML input type. */
  type: PropTypes.string
};
Input.create = createShorthandFactory(Input, function (type) {
  return {
    type: type
  };
});
export default Input;
//# sourceMappingURL=index.js.map